export const getCountryKey = (obj, currency) => {
  const correlatedCountry = Object.keys(obj).filter(key => obj[key] === currency)
  return correlatedCountry.length > 1 ? 'US' : correlatedCountry.toString()
}
